import gql from 'graphql-tag';

export const REJECT_ORDER_REFUND = gql`
  mutation rejectOrderRefundByFinancial($input: RejectOrderRefundByFinancialInput!) {
    rejectOrderRefundByFinancial(input: $input) {
      orderRefund {
        status
        rejectReason
      }
    }
  }
`;

export const REFUND_ORDER_REFUND = gql`
  mutation refundOrderRefundByFinancial($input: RefundOrderRefundByFinancialInput!) {
    refundOrderRefundByFinancial(input: $input) {
      orderRefund {
        status
        refundMethod
        rejectReason
      }
    }
  }
`;
